import styled from '@emotion/styled';

export const SectionContainer = styled.div`
  text-align: center;
`;

export const SectionTitle = styled.h2`
  font-weight: 600;
  font-size: 36px;
  margin-bottom: 10px;
`;